import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./Home.css";
import ServicesSection from "./Services";
import Gallery from "./Gallery";
import Review from "./Review";
import eventbg1 from "../../../Assets/HeroSection/eventbg1.jpg";
import eventbg2 from "../../../Assets/HeroSection/eventbg2.jpg";
import eventbg3 from "../../../Assets/HeroSection/eventbg3.jpg";
import eventbg4 from "../../../Assets/HeroSection/eventbg4.jpg";

const images = [eventbg1, eventbg2, eventbg3, eventbg4];

const Home = () => {
  const navigate = useNavigate();
  const [currentImage, setCurrentImage] = useState(eventbg1);
  const [fadeOut, setFadeOut] = useState(false);
  const [loading, setLoading] = useState(true); // ⬅ splash loader

  // Hero background image slider
  useEffect(() => {
    const interval = setInterval(() => {
      setFadeOut(true);
      setTimeout(() => {
        setCurrentImage((prevImage) => {
          const currentIndex = images.indexOf(prevImage);
          const nextIndex = (currentIndex + 1) % images.length;
          return images[nextIndex];
        });
        setFadeOut(false);
      }, 1500);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  // Splash screen loader
  useEffect(() => {
    const handleLoad = () => {
      setTimeout(() => setLoading(false), 1000); // buffer
    };

    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
    }

    return () => window.removeEventListener("load", handleLoad);
  }, []);

  const handleExploreClick = () => {
    navigate("/services");
  };

  return (
    <>
      {loading ? (
        <div className="splash-screen">
          <img
            src={process.env.PUBLIC_URL + "Logo.png"} // <-- Replace with your actual logo path or import
            alt="Reliable Events Logo"
            className="splash-logo"
          />
        </div>
      ) : (
        <>
          <Helmet>
            <title>Reliable Events - Best Event Planner in Udaipur</title>
            <meta
              name="description"
              content="Looking for a trusted event planner in Udaipur? Reliable Events offers expert planning for weddings, parties, and corporate events."
            />
            <meta
              name="keywords"
              content="event planner in udaipur, event management, Udaipur, weddings, corporate events"
            />
            <link rel="canonical" href="https://reliableeventsudaipur.com/" />
            <script type="application/ld+json">
              {JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Organization",
                name: "Reliable Events",
                url: "https://reliableeventsudaipur.com/",
                logo: "%PUBLIC_URL%/Logo.png",
                sameAs: [
                  "https://www.facebook.com/share/KTMr6F5EmFgrdHYh/?mibextid=LQQJ4d",
                  "https://www.instagram.com/reliable_events_udaipur"
                ],
                address: {
                  "@type": "PostalAddress",
                  streetAddress: "Sunderwas",
                  addressLocality: "Udaipur",
                  addressRegion: "Rajasthan",
                  postalCode: "313001",
                  addressCountry: "India"
                },
                contactPoint: {
                  "@type": "ContactPoint",
                  telephone: "+91-6378394687",
                  contactType: "customer service",
                  areaServed: "IN",
                  availableLanguage: "Hindi, English"
                }
              })}
            </script>
          </Helmet>

          <header className="hero-section">
            <div className="image-slider" aria-label="Background Image Slider">
              <div className="slider-line"></div>
              <div
                className={`image-slide ${fadeOut ? "fade-out" : "fade-in"}`}
                style={{
                  backgroundImage: `url(${currentImage})`,
                }}
                role="img"
                aria-label="Event background"
                alt="Beautiful event background"
                loading="lazy"
              ></div>
            </div>
            <div className="hero-content">
              <h1 className="animate-text">Creating Unforgettable Memories</h1>
              <p className="animate-subtext">
                We Plan, Design, and Manage exceptional celebrations for any
                Occasion.
              </p>
              <button className="cta-btn" onClick={handleExploreClick}>
                Explore Our Services
              </button>
            </div>
          </header>

          <main>
            <section id="services" aria-labelledby="services-title">
              <h2 id="services-title" className="sr-only">
                Our Services
              </h2>
              <ServicesSection />
            </section>
            <section id="gallery" aria-labelledby="gallery-title">
              <h2 id="gallery-title" className="sr-only">
                Gallery
              </h2>
              <Gallery />
            </section>
            <section id="reviews" aria-labelledby="reviews-title">
              <h2 id="reviews-title" className="sr-only">
                Client Reviews
              </h2>
              <Review />
            </section>
          </main>
        </>
      )}
    </>
  );
};

export default Home;
